import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './styles.css';
import { AppContainer } from './AppContainer';
import { ErrorBoundary } from './components/common';

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <ErrorBoundary>
            <AppContainer />
        </ErrorBoundary>
    </StrictMode>,
);
